<template>
	<div>
		<ContactCard @onAccountChange="handleChangeAccount" :shadow="shadow" :customerId="customerId" :showWebAccess="showWebAccess" v-if="type=='primary'" v-for="c in primaryContacts" v-bind:key="c.id" v-bind:contact="c" v-bind:isIndividual="isIndividual" style=" margin: 5px;"></ContactCard>
		<div v-if="type=='primary' && primaryContacts.length==0" class="secondary-text fs-14">{{$t('contact.noPrincipalContact')}}</div>
		<ContactCard @onAccountChange="handleChangeAccount" v-if="type=='secondary'" :customerId="customerId" :showWebAccess="showWebAccess" :shadow="shadow" v-for="c in secondaryContacts" v-bind:key="c.id" v-bind:contact="c" v-bind:secondary="true" style=" margin: 5px;"></ContactCard>
		<div v-if="type=='secondary' && secondaryContacts.length==0" class="secondary-text fs-14">{{$t('contact.noSecondaryContact')}}</div>
	</div>
</template>
<script>
import ContactCard from '@/components/Contact-card'
export default {
	name: 'ClientCard',
	methods: {
		handleChangeAccount (account) {
			this.$emit('onAccountChange', account);
		},
	},
	computed : {
		primaryContacts(){
			if(this.isIndividual){
				return this.contacts;
			}else{
				return _.filter(this.contacts, c=>{
					return (c.ind_primary && c.active==true)
				})
			}
		},
		secondaryContacts(){
			return _.filter(this.contacts, c=>{
				return ((c.ind_primary==false || c.ind_primary==null) && c.active==true)
			})
		},
		showSecondaryContacts(){
			if(this.contacts==null) return false;
			return this.secondaryContacts.length>0 && !this.isIndividual;
		}
	},
	components : {
		ContactCard
	},
	props: {
		contacts : Array,
		isIndividual : Boolean,
		showWebAccess: {
			type: Boolean,
			default: false,
		},
		type : {
			type : String,
			required : true,
			default : 'primary'
		},
		shadow : {
			type : String,
			default : 'never'
		},
		customerId: {
			type: Number,
		},
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
